import React from "react";
import { JobDetails } from "./JobDetails";
import { PublicJobDescription } from "./publicJobDescription";
import { useGetUserInfo } from "hooks/useGetUserInfo";

export default function JobDetailsRoute() {
  const { userInfo } = useGetUserInfo();

  return userInfo ? <JobDetails /> : <PublicJobDescription />;
}
